import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useCreateTenant } from './tenants.api';

export function NewTenantPage(): JSX.Element {
  const navigate = useNavigate();
  const create = useCreateTenant();
  const [f, setF] = useState({
    ruc: '',
    businessName: '',
    tradeName: '',
    ownerEmail: '',
    ownerName: '',
    ownerPassword: '',
  });
  const set = (k: keyof typeof f) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(
      {
        ruc: f.ruc.trim(),
        businessName: f.businessName.trim(),
        tradeName: f.tradeName.trim() || undefined,
        owner: { email: f.ownerEmail.trim(), name: f.ownerName.trim(), password: f.ownerPassword },
      },
      { onSuccess: () => navigate('/empresas') },
    );
  };

  return (
    <div className="max-w-xl space-y-5">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Nueva empresa</h1>
        <p className="text-sm text-muted-foreground">
          Crea el tenant y su usuario owner. Se genera series F001/B001 y una suscripcion en prueba.
        </p>
      </div>

      <form onSubmit={submit} className="rounded-2xl border border-border bg-card p-5 shadow-sm space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="RUC">
            <Input value={f.ruc} onChange={set('ruc')} maxLength={11} placeholder="20123456789" required />
          </Field>
          <Field label="Razon social">
            <Input value={f.businessName} onChange={set('businessName')} placeholder="Mi Empresa SAC" required />
          </Field>
        </div>
        <Field label="Nombre comercial (opcional)">
          <Input value={f.tradeName} onChange={set('tradeName')} placeholder="Mi Empresa" />
        </Field>

        <div className="pt-2 border-t">
          <p className="text-sm font-medium mb-3">Usuario owner</p>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Email">
              <Input type="email" value={f.ownerEmail} onChange={set('ownerEmail')} required />
            </Field>
            <Field label="Nombre">
              <Input value={f.ownerName} onChange={set('ownerName')} required />
            </Field>
          </div>
          <div className="mt-4">
            <Field label="Contraseña (min 8)">
              <Input type="password" value={f.ownerPassword} onChange={set('ownerPassword')} minLength={8} required />
            </Field>
          </div>
        </div>

        <div className="flex gap-2 pt-2">
          <Button type="submit" disabled={create.isPending}>
            {create.isPending ? 'Creando…' : 'Crear empresa'}
          </Button>
          <Button type="button" variant="outline" onClick={() => navigate('/empresas')}>
            Cancelar
          </Button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }): JSX.Element {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      {children}
    </div>
  );
}
